import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';

async function fetchTypes({ commit }) {
  try {
    const { data } = await HTTPService.fetchTwoFactorTypes();
    commit('SET_TYPES', data);
  } catch (error) {
    logrocket.logger(error);
    commit('SET_TYPES', null);
  }
}

async function changeSelection({ commit }, type) {
  try {
    const { data } = await HTTPService.twoFactorSelect(type);
    commit('SET_CURRENT', data);
  } catch (error) {
    logrocket.logger(error);
    commit('SET_CURRENT', null);
  }
}

async function twoFactorCancel({ commit }) {
  try {
    await HTTPService.twoFactorCancel();
  } catch (error) {
    logrocket.logger(error);
  }

  commit('SET_CURRENT', null);
}

export default {
  fetchTypes,
  changeSelection,
  twoFactorCancel,
};
